import React from 'react';
import {
  Colors,
  Divider,
  Flex,
  IconChevronRight,
  PrimaryButton,
  Typography,
} from '@banhala/ui-kit';

type InquiryGoodsQuestionProps = {
  onClickNotice: () => void;
  onClickInquiry: () => void;
};

export const InquiryGoodsQuestion: React.FC<InquiryGoodsQuestionProps> = ({
  onClickNotice,
  onClickInquiry,
}) => {
  return (
    <>
      <Flex.Row
        alignItems="center"
        justifyContent="space-between"
        padding={{ horizontal: 16, vertical: 24 }}
        onPress={onClickNotice}
      >
        <Typography type="h5" color="content_primary">
          배송 / 결제 / 교환 / 반품 안내
        </Typography>
        <IconChevronRight
          width={16}
          height={16}
          fill={Colors.content_tertiary}
        />
      </Flex.Row>
      <Divider size="small" />
      <Flex padding={{ horizontal: 16, vertical: 24 }} rowGap={16}>
        <Typography type="h5" color="content_primary" marginBottom={8}>
          지금 보고 있는 상품이 궁금하신가요?
        </Typography>
        <QuestionRow example="상품 사이즈 및 옵션에 대해서 궁금해요" />
        <QuestionRow example="상품 재입고 언제되는지 궁금해요" />
        <Flex margin={{ top: 16 }}>
          <PrimaryButton
            // type="round"
            variant={'fill'}
            size="medium"
            outline
            color="gray"
            onPress={onClickInquiry}
          >
            상품 문의하기
          </PrimaryButton>
        </Flex>
      </Flex>
    </>
  );
};

const QuestionRow: React.FC<{ example: string }> = ({ example }) => {
  return (
    <Flex.Row alignItems="center" columnGap={12}>
      <Flex
        padding={{ horizontal: 4, vertical: 2 }}
        borderRadius={2}
        borderWidth={1}
        borderColor="border_secondary"
      >
        <Typography type="body6" color="content_primary">
          예시
        </Typography>
      </Flex>
      <Typography type="body2" color="content_secondary">
        {example}
      </Typography>
    </Flex.Row>
  );
};
